// dependencies
import { GenerateProcess } from "redux-process";

export const fetchSignatureTemplates = () => (dispatch) => {
	dispatch(GenerateProcess("GetSignatureTemplates"));
};
